import { HARC_TUR_AKTIF_TARIFE_GETIR } from "../constants/requestUrls";
import { getRequest } from "../request";

const HarcTurAktifTarifeGetir = (kbsServisId,yrsTurId) => {
    const data = {};
    let url=HARC_TUR_AKTIF_TARIFE_GETIR+"?kbsServisId="+kbsServisId+"&yrsTurId="+yrsTurId;
    return getRequest({url:url,data});
}

export default HarcTurAktifTarifeGetir;